import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators,UntypedFormControl } from '@angular/forms';
import { ConfirmedValidator } from '@app/_services/confirmed.validator';
import { AccountService} from '@app/_services';
import { first } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import {Router, NavigationExtras, Event, NavigationStart, NavigationError} from "@angular/router"


@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.css']
})
export class PasswordComponent implements OnInit {
  passwordForm: UntypedFormGroup;
  submitted = false;
  isLoading = false;
  user_id
  constructor(private router: Router, private formBuilder: UntypedFormBuilder,private accountService: AccountService, private toastr: ToastrService) { }

    ngOnInit(): void {
      var userdata = localStorage.getItem('userInformation');
      var _data = JSON.parse(userdata);
      if(_data) {
        this.user_id = _data.id;
      }

      this.passwordForm = this.formBuilder.group({
          o_password: ['', Validators.required],
          password: ['', [Validators.minLength(6), Validators.required]],
          confirmPassword: ['',  Validators.required ],
      },{
          validator: ConfirmedValidator('password', 'confirmPassword'),
      });
  
    }
    

    get formU() { return this.passwordForm.controls; }
    onPasswordChange(){
      this.submitted = true;

      if (!this.passwordForm.valid) {
        return;
      }
      if(this.formU.password.value ===this.formU.o_password.value){
        this.toastr.warning("Old and New Password should not be same.", "Warning");
        return;
      }

      const formDataNew = new FormData();   
        formDataNew.append('id',this.user_id);
        formDataNew.append('o_password', this.passwordForm.get('o_password').value);
        formDataNew.append('password', this.passwordForm.get('confirmPassword').value);

        this.isLoading = true;
        this.accountService.changepassword(formDataNew)
          .pipe(first())
          .subscribe(
          (response) => {
           this.resetForm();
            if(response.state == "ERROR") {
              this.toastr.warning(response.message, "Warning");
            } else if(response.state == "SUCCESS") {
              this.toastr.success("Password changed successfully", "Success");
                  this.router.navigate(['/dashboard'])

            }
            this.isLoading = false;
          },
          (error) => {        
            this.isLoading = false;
          }
        );
    }
 resetForm() {
    this.passwordForm.reset();
    this.passwordForm.setErrors(null); // could be removed
    this.passwordForm.updateValueAndValidity();
  } 


  }


